<template>
    <div class="zhuanshudingding">
        <div class="banner"></div>
        <div class="cont1">
            <div class="box-cont1">
                <p class="title-box">大型组织数字化协同办公面临的挑战</p>
                <p class="con-box">如何应对大型组织行业合规和安全化诉求、业务管理与协同沟通割裂问题，着力搭建一体化成本适宜、安全高效组织协同管理平台。</p>
                <ul class="ul-box">
                    <li>
                        <img src="http://img601.yun300.cn/repository/image/ae91f2b1-26a7-4a0c-93dc-626a9809058d.jpg?tenantId=214689&viewType=1&k=1651226704000" alt="" loading="lazy">
                        <p class="pp1">大型组织对硬核技术依赖增强</p>
                        <p class="pp2">硬核技术周期长、投入大、维护难，分散企业</p>
                        <p class="pp2">IT精力，成为业务数字化阻力</p>
                    </li>
                    <li>
                        <img src="http://img601.yun300.cn/repository/image/1f916d33-b1a5-47de-a53b-e0e1a3f3d462.jpg?tenantId=214689&viewType=1&k=1651226704000" alt="" loading="lazy">
                        <p class="pp1">移动应用投资高成效低</p>
                        <p class="pp2">缺乏统一标准支撑平台，容易重复建设，用户</p>
                        <p class="pp2">体验参差不齐</p>
                    </li>
                    <li>
                        <img src="http://img601.yun300.cn/repository/image/c44510ae-565b-47e8-bfd5-a53b602b8efc.jpg?tenantId=214689&viewType=1&k=1651226704000" alt="" loading="lazy">
                        <p class="pp1">难以快速响应业务创新</p>
                        <p class="pp2">多年信息化堆叠，垂直化建设，集成能力和开</p>
                        <p class="pp2">放能力不符合业务创新</p>
                    </li>
                </ul>
            </div>
            <p class="title-box-x">大型组织数字化协同办公面临的挑战</p>
            <div class="jishao">
                <img src="http://img601.yun300.cn/repository/image/aefaebd5-69f1-4d06-91c1-88458f431197.jpg?tenantId=214689&viewType=1&k=1651226704000" alt="" loading="lazy">
                <div class="right-jiashao">
                    <p class="p-jiashao1">专有钉钉数字化协同平台应用云计算、大数据和移动互联网技术，实现跨层级、跨地域、跨部门、跨业务、跨系统的协同管理和服务。通过结构化的产品支撑体系、业务编排和开放集成能力，构建本地繁荣协同应用生态，支持专有化部署，采取国密加密，安全合规。</p>
                    <p class="changjing">适用场景</p>
                    <p class="one-jiaoshoa">1、助力部委、省、市、县各级政务组织打造协同共治、政企互通的数字化平台，打造高效服务型政府。</p>
                    <p class="one-jiaoshoa">2、快速响应各行业业务领域创新、数字化转型诉求，构建一体化生态数字化沟通和协同平台。</p>
                </div>
            </div>
            <div class="box2-cont1">
                <p class="miderTitle">解决方案架构介绍</p>
                <div class="line"></div>
                <p class="letter-title">在钉钉强大的组织、沟通、协同、业务和生态在线的基座上助力企业打造专属、安全、开放的数字化办公运营平台。</p>
                <ul class="box2-ul">
                    <li>
                        <p class="ps1">硬核技术</p>
                        <p class="lin-yuanjiao"></p>
                        <p class="ps2">快速响应各行业业务领域创新</p>
                        <!-- <p class="ps2">义自己的工作和学习方式，轻松实现千人千面</p> -->
                    </li>
                    <li>
                        <p class="ps1">部署方式</p>
                        <p class="lin-yuanjiao"></p>
                        <p class="ps2">灵活支持专网部署和本地部署</p>
                        <!-- <p class="ps2">专属数据空间实现业务与数据的分离</p> -->
                    </li>
                    <li>
                        <p class="ps1">开放集成</p>
                        <p class="lin-yuanjiao"></p>
                        <p class="ps2">更开放设计与集成能力高效接入业务应用</p>
                        <!-- <p class="ps2">业务系统，全面提升业务协同效率</p> -->
                    </li>
                </ul>

            </div>
        </div>
        <div class="cont2">
            <p class="miderTitles">推荐功能</p>
            <ul class="tuijian">
                <li>
                    <div class="left">
                        <img src="http://img601.yun300.cn/repository/image/bca81c98-0244-499f-8e50-206fbe5189a4.png?tenantId=214689&viewType=1&k=1651226704000" alt="" loading="lazy">
                    </div>
                    <div class="right">
                        <p class="right-title">统一业务平台</p>
                        <p class="right-info">支持统一应用生态的建设和运营，统一标准支撑平台，助力业务融合，建设重复建设</p>
                    </div>
                </li>
                <li>
                    <div class="left">
                        <img src="http://img601.yun300.cn/repository/image/b3bbcd39-b088-42df-a23c-42b9cd87465c.png?tenantId=214689&viewType=1&k=1651226704000" alt="" loading="lazy">
                    </div>
                    <div class="right">
                        <p class="right-title">超大组织管理</p>
                        <p class="right-info">支持超大组织管理，可实现百万人员轻松管理；分级权限精细管理实现千人千面的工作台。</p>
                    </div>
                </li>
                <li>
                    <div class="left">
                        <img src="http://img601.yun300.cn/repository/image/ecc66232-dcab-4b63-b964-9734239d48bd.png?tenantId=214689&viewType=1&k=1651226704000" alt="" loading="lazy">
                    </div>
                    <div class="right">
                        <p class="right-title">多种部署方式</p>
                        <p class="right-info">支持飞天、敏捷、物理机等多平台私有化部署，满足各类应用环境需求。</p>
                    </div>
                </li>
                <li>
                    <div class="left">
                        <img src="http://img601.yun300.cn/repository/image/da170edc-b874-40dc-9763-f6f97575f709.png?tenantId=214689&viewType=1&k=1651226704000" alt="" loading="lazy">
                    </div>
                    <div class="right">
                        <p class="right-title">安全全面护航</p>
                        <p class="right-info">国密算法、等保三级，全面安全护航数字化协同办公</p>
                    </div>
                </li>
            </ul>
            <div class="zhuanjia">
                <p class="bushuzhuanjia">部署专家免费服务</p>
                <p class="zhuanjiafuwu"><span>联系部署专家：</span>根据您提交的需求，将有钉钉部署专家免费为您服务！</p>
                <div class="btn-zixun" @click="jumpZX">立即咨询</div>
            </div>
            <div class="sssdd"></div>
        </div>
    </div>
</template>

<script>
export default {
   methods: {
       jumpZX(){
                   window.open('https://affim.baidu.com/unique_45505196/chat?siteId=19205659&userId=45505196&siteToken=77fa0eaf9cff4d1ebd63763b42b6da96')

       }
   }
}
</script>
<style lang='less' scoped>
.zhuanshudingding{
    width: 100%;
    text-align: left;
    .banner{
        width:100% ;
        height: 450px;
        background-image: url(./banner-pc-img/jjfa_zydd_1920337.5@1x-tuya.png);
        background-size: 100% 100%;
        background-repeat: no-repeat;
        cursor: pointer;
    }
    .cont1{
        width: 100%;
        .box-cont1{
            width: 80%;
            margin: 40px auto;
            background-color: rgba(255, 255, 255, 1);
           box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;
            border-radius: 6px;
            padding: 40px 90px;
            .title-box{
                font-size: 30px;
                color: #000;
                line-height: 40px;
                letter-spacing: 2px;
            }
            .con-box{
                font-size: 20px;
                line-height: 25px;
                color:#696969;
                margin-top: 20px;
            }
            .ul-box{
                width: 100%;
                margin-top: 43px;
                display: flex;
                justify-content: space-between;
                li{
                    width: 30%;
                    text-align: center;
                    img{
                        width: 100%;
                         height: 250px;

                    }
                    .pp1{
                        font-size:24px;
                        color:#000000;
                        text-align: center;
                        line-height: 45px;
                        font-weight: bold;
                        letter-spacing: 2px;
                        margin-top: 10px;
                    }
                    .pp2{
                        font-size:18px;
                        color:#808080;
                        text-align: center;
                        line-height: 30px;
                    }
                }
            }
        }
        // ----
        .title-box-x{
            font-size: 30px;
            color: #000;
            text-align: center;
        }
        .jishao{
            width: 80%;
            background-color: rgb(247,247,247);
            margin: 40px auto;
            border-radius: 6px;
            padding: 10px 20px;
            display: flex;
            justify-content: space-around;
            img{
                width: 35%;
                height: 400px;
            }
            .right-jiashao{
                flex: 1;
                padding-top: 20px;
                padding-right: 15px;
                padding-left: 55px;
                .p-jiashao1{
                    font-size: 24px;
                    color: #000;
                    line-height: 33px;
                    letter-spacing: 1px;
                }
                .changjing{
                    color:#0089ff;
                    font-size: 23px;
                    line-height: 25px;
                    margin-top: 20px;
                    margin-bottom: 12px;
                }
                .one-jiaoshoa{
                    font-size: 21px;
                    line-height: 35px;
                }

            }

        }
        // ---
        .box2-cont1{
            width: 100%;
            .box2-ul{
                width: 80%;
                margin: 50px auto;
                display: flex;
                justify-content: space-between;

                li{
                    width: 31%;
                    padding: 50px;
                    background-image: url("https://img.alicdn.com/tfs/TB15Q3KDhD1gK0jSZFKXXcJrVXa-370-184.png");
                    background-repeat: no-repeat;
                    background-size: 100% 100%;
                    .ps1{
                        font-size: 25px;
                        font-weight: 100;
                        color: #fff;
                        text-align: center;
                        line-height: 40px;
                    }
                    .lin-yuanjiao{
                        width: 50px;
                        height: 3px;
                        border-radius: 6px;
                        background-color: #fff;
                        margin: 0 auto;
                        margin-bottom: 22px;
                        margin-top: 13px;
                    }
                    .ps2{
                        font-size: 18px;
                        color:#FFFFFF;
                        line-height: 26px;
                        text-align: center;
                        letter-spacing: 1px;
                        margin-top: 5px;
                    }
                }
            }
        }


    }

    .cont2{
        width: 100%;
        background-color: #F7F7F7;
        .miderTitles{
            font-size: 30px;
            text-align: center;
            color: #000;
            line-height: 130px;
        }
        .tuijian{
            width: 80%;
            margin: auto;
            display: flex;
            flex-wrap: wrap;
            justify-content: space-around;
            li{
                width: 47%;
                height: 206px;
                background-color: #fff;
                transition: all 0.2s linear;
                margin-bottom: 40px;
                display: flex;
                cursor: pointer;
                .left{
                    width: 250px;
                    height: 100%;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    img{
                        width: 85px;
                        height: 65px;
                    }
                }
                .right{
                    flex: 1;
                    padding-right: 30px;
                    .right-title{
                        margin-top: 59px;
                        font-size: 28px;
                        color: #252525;
                        font-weight: 100;
                    }

                    .right-info{
                        font-size: 19px;
                        margin-top: 15px;
                        color: #7A7A7A;
                        font-weight: 100;
                        line-height: 30px;
                    }
                }
            }
            li:hover{
                box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
            }
        }
        .zhuanjia{
            width: 80%;
            background-color: #fff;
            margin: auto;
            padding: 50px;
            position: relative;
            .bushuzhuanjia{
                font-size: 24px;
                color:#000000;
                font-weight: bold;
            }
            .zhuanjiafuwu{
                color:#696969;
                font-size: 19px;
                margin-top: 20px;
                span{
                    color:#0089ff;
                }
            }
            .btn-zixun{
                padding: 15px 40px;
                text-align: center;
                color: #fff;
                background-color: rgba(0, 137, 255, 1);
                position: absolute;
                right: 50px;
                top: 65px;
                border-radius: 4px;
                cursor: pointer;
            }
        }
        .sssdd{
            height: 40px;
        }
    }
}
.miderTitle{
    font-size: 35px;
    text-align: center;
    color: #000;
    line-height: 50px;
}
.line{
   width: 40px;
    height: 2px;
    background-color: rgba(0, 137, 255, 1);
    margin: 0 auto;
    margin-top: 12px;
 }
 .letter-title{
    font-size: 21px;
    text-align: center;
   color: #000;
    line-height: 30px;
     margin-top: 15px;
}
</style>
